import { render, staticRenderFns } from "./RejectCandidate.vue?vue&type=template&id=04958be1&"
import script from "./RejectCandidate.vue?vue&type=script&lang=js&"
export * from "./RejectCandidate.vue?vue&type=script&lang=js&"
import style0 from "./RejectCandidate.vue?vue&type=style&index=0&id=04958be1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports